import React from "react"

import logo from '../images/KK_logo_keskitetty_sf_swe_rgb_black.png';
import logo_eng from '../images/KK_logo_keskitetty_eng_rgb_black.jpg';

import lang from '../Localization';

class InfoDisplay extends React.Component {
    render() {
        let l = lang.getLanguage() === "en" ? logo_eng : logo;
        return (
            <div style={{textAlign: "center"}}>
                <img src={l} alt="Kansalliskirjaston logo" style={{width: "150px"}} />
                <h1>{lang.welcome}</h1>
                <h2>{lang.infoText}</h2>
                <h2>{lang.infoTextMultiple}</h2>
            </div>
        );
    }
  }

  export { InfoDisplay }